import React, { Fragment, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import config from '../../config';
function ModalCompanyCreate({ callback }) {
  const [show, setShow] = useState(false);
  const [nombre, setnombre] = useState("");
  const [nit, setnit] = useState("");
  const [digito_verificacion, setdigito_verificacion] = useState("");

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const createcompany = () => {
    const datasend = {
      method: 'POST',
      body: JSON.stringify({
        nombre,
        nit,
        digito_verificacion
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    };
    fetch(config.servBackEnd + '/companies/create_new', datasend).then(response => response.json())
      .then(data => {
        setShow(false)
        callback(data)
      });
  }

  return (
    <Fragment>
      <Button className='mb-3' variant="primary" onClick={handleShow}>
        Crear Empresa
      </Button>

      <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Crear Empresa</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group controlId="formGridEmpresa">
            <Form.Label>Empresa</Form.Label>
            <Form.Control type="text" placeholder="Empresa" onChange={(e) => setnombre(e.target.value)} value={nombre} required />
          </Form.Group>
          <Form.Group controlId="formGridEmpresa">
            <Form.Label>Nit</Form.Label>
            <Form.Control type="text" placeholder="Empresa" onChange={(e) => setnit(e.target.value)} value={nit} required />
          </Form.Group>
          <Form.Group controlId="formGridEmpresa">
            <Form.Label>DV</Form.Label>
            <Form.Control type="text" placeholder="Empresa" onChange={(e) => setdigito_verificacion(e.target.value)} value={digito_verificacion} required />
          </Form.Group>

        </Modal.Body>
        <Modal.Footer>
          <Fragment>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button variant="primary" onClick={createcompany}>
              Save Changes
            </Button>
          </Fragment>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
}

export default ModalCompanyCreate;


// WEBPACK FOOTER //
// ./src/components/subcomponent/companyModuleCreateCompany.jsx